if (!customElements.get('wishlist-header-button')) {
  customElements.define(
    'wishlist-header-button',
    class WishlistHeaderButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.bubble = this.querySelector('.wishlist-count-bubble');
        this.empty = true;
        this.count = 0;
      }
      connectedCallback() {
        this.button.addEventListener('click', this.handleButtonClick.bind(this));
        this.init();
      }
      disconnectedCallback() {
        this.button.removeEventListener('click', this.handleButtonClick);
      }
      async init() {
        const customerId = await handleLogIn();
        if (!customerId || !this.bubble) return; // don't do anything if the customer isn't logged in or if it's the mobile drawer button

        const response = await fetch(
          'https://limelace-wishlist.etempashopifyapps-server-i.co.uk/endpoints/retrieve_wishlist.php',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              customer_id: customerId,
            }),
          }
        );
        const data = await response.json();
        if (data.failed) {
          console.error('Error retrieving wishlist');
          throw new Error('Something went wrong retrieving your wishlist');
        } else if (!Boolean(data.wishlist_empty)) {
          this.count = Number(data.wishlist_count);
          this.fillWishlist();
        }
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }
      fillWishlist() {
        this.empty = false;
        if (!this.bubble) return;

        this.bubble.classList.remove('empty');
        Array.from(this.bubble.querySelectorAll('span')).map((span) => (span.textContent = this.count));
      }
      async openWishlist() {
        this.button.classList.add('loading');

        const customerId = await handleLogIn();
        if (customerId) {
          window.location.href = `/pages/wishlist`;
        } else {
          window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent('/pages/wishlist')}`;
          return false;
        }

        this.button.classList.remove('loading');
      }
      handleButtonClick(e) {
        e.preventDefault();
        if (this.button.classList.contains('loading')) {
          return;
        }
        this.openWishlist();
      }
    }
  );
}
